app.ui.registerUi('confirm', function (app) {
    var helpers = app.helpers.funcs;
	return {
        fire: function (msg) {
            return confirm(msg);
        }
	};
});